import {useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'
import {useCsat} from '@adv-mt/mt-tracking-use-csat'

/**
 * Registers a list view (no adId) or an ad detail view (adId) in session state
 * and fires the CSAT/NPS Hotjar trigger once the session becomes eligible.
 *
 * The trigger runs in its own effect: useCsat ignores trigger calls made before
 * it has mounted, which is the case for the first mount effect.
 */
export default function useCsatNps({adId, isDisabled} = {}) {
  const {domain} = useContext(Context)
  const {trigger} = useCsat()
  const [isEligible, setIsEligible] = useState(false)

  const config = domain.get('config')
  const {HAS_CSAT_NPS_ENABLED} = config.get('features')
  const {TRIGGER_NAME} = config.get('COMMON').CSAT_NPS
  const isEnabled = Boolean(HAS_CSAT_NPS_ENABLED) && !isDisabled

  useEffect(() => {
    if (!isEnabled) return

    let isActive = true

    domain
      .get('register_csat_nps_visit_tracking_use_case')
      .execute({adId})
      .then(([error, result]) => {
        if (isActive) setIsEligible(!error && Boolean(result?.isEligible))
      })

    return () => {
      isActive = false
    }
  }, [adId, isEnabled]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isEligible) return

    trigger(TRIGGER_NAME)
    domain.get('mark_csat_nps_triggered_tracking_use_case').execute()
  }, [isEligible]) // eslint-disable-line react-hooks/exhaustive-deps
}
